import GoodwillService from 'services/dealDriver/goodwill.service';
import { createServiceAsyncThunkFactory } from 'store/helpers/createServiceAsyncThunkFactory';

const DEFAULT_SUBMIT_ERROR_MESSAGE = 'Failed to submit this request. Please try again.';

const DEFAULT_INDEX_ERROR_MESSAGE = 'Fail to retreive discount requests.  Please try again.';

const createDealDriverAsyncThunk = createServiceAsyncThunkFactory();

export const createDiscountApprovalRequest = createDealDriverAsyncThunk(
	'dealDriverGoodwill/updateDiscountApprovalRequest',
	async (
		{ bidSaleId, requestId, isApproved = false, isDenied = false, acknowledged = false, denialReason = null } = {},
		thunkAPI,
	) => {
		const response = await GoodwillService.instance.updateApprovalRequest(
			bidSaleId,
			requestId,
			isApproved,
			isDenied,
			acknowledged,
			denialReason,
		);
		const responseData = response?.data;

		if (responseData?.success === false) {
			return thunkAPI.rejectWithValue(
				responseData?.message || responseData?.errors?.[0] || DEFAULT_SUBMIT_ERROR_MESSAGE,
			);
		}

		return {
			bidSaleId,
			responseData,
		};
	},
	(error) => {
		const isServerConfirmationRequired =
			error?.status === 422 &&
			Boolean(error?.error?.requires_confirmation) &&
			error?.error?.reason === 'transaction_locked';

		if (isServerConfirmationRequired) {
			return error;
		}

		return error?.error?.message || error?.error?.errors?.[0] || DEFAULT_SUBMIT_ERROR_MESSAGE;
	},
);

export const getAllDiscountApprovalRequests = createDealDriverAsyncThunk(
	'dealDriverGoodwill/getAllDiscountApprovalRequests',

	async ({ page } = {}, { getState, rejectWithValue }) => {
		const {
			dealDriver: { filters },
			dealDriverGoodwill: { sorting, page: currentPage, statuses },
		} = getState();
		const requestedPage = page ?? currentPage ?? 1;
		const discountsFilters = {
			keywords: filters?.keywords,
			deal_worker: filters?.deal_worker,
			statuses: statuses?.length ? statuses.join(',') : undefined,
		};
		const response = await GoodwillService.instance.getAll({
			page: requestedPage,
			sorting,
			filters: discountsFilters,
		});

		const responseData = response?.data;

		if (responseData?.success === false) {
			return rejectWithValue(responseData?.message || responseData?.errors?.[0] || DEFAULT_INDEX_ERROR_MESSAGE);
		}

		const { data, metadata } = responseData || {};
		const discountApprovalRequests = data || [];

		return { discountApprovalRequests, metadata };
	},
	(error) => error?.error?.message || error?.error?.errors?.[0] || DEFAULT_INDEX_ERROR_MESSAGE,
);
